import React, {Component} from 'react';
import { useCountUp }  from 'react-countup';
import  CountUp, { startAnimation }  from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const style = {
  componentName: {},
  col: {},
  countup: {},
};
 
class Counter extends Component {

  state = {
    didViewCountUp: false
  };

  onVisibilityChange = isVisible => {
    if (isVisible) {
      this.setState({didViewCountUp: true});
    }
  }



  render() {
    return (
 <div>

   <section className="gradient-bg">
     
   <VisibilitySensor onChange={this.onVisibilityChange} offset={{
          top:
            10
        }} delayedCall>
       <div className="container">
     
         <div className="row align-items-center">
           {/* Single Counter */}
           <div className="col-lg-3 col-sm-6">
             <div className="single-counter text-center text-white">
               <h2 className="count">
                   <CountUp className={style.countup} start={0} end={this.state.didViewCountUp ? 12 : 0}
                   duration={5}
                     />
               </h2>

                 <p>Years of experience</p>

           </div>
           </div>
           
           {/* End Single Counter */}
           {/* Single Counter */}
           <div className="col-lg-3 col-sm-6">
             <div className="single-counter text-center text-white">
               <h2 className="count">
                 <CountUp className={style.countup}  start={0} end={this.state.didViewCountUp ? 162 : 0}
                  duration={5}
                   />+
               </h2>
               <p>Happy Clients</p>
             </div>
           </div>
          
           {/* End Single Counter */}
           {/* Single Counter */}
           <div className="col-lg-3 col-sm-6">
             <div className="single-counter text-center text-white">
               <h2 className="count">
                 <CountUp className={style.countup}  start={0} end={this.state.didViewCountUp ? 853 : 0}
                  duration={5}
                   />+
               </h2>
               <p>Projects Done</p>
             </div>
           </div>
           {/* End Single Counter */}
           {/* Single Counter */}
           <div className="col-lg-3 col-sm-6">
             <div className="single-counter text-center text-white">
               <h2 className="count">
                 <CountUp className={style.countup} start={0} end={this.state.didViewCountUp ? 65 : 0}
                    duration={5}
                   />+
               </h2>
               <p>Giving Consultancy</p>
             </div>
           </div>
           {/* End Single Counter */}
          
         </div>
     </div>
         </VisibilitySensor>
        
   </section>

 </div>
     
    )
}
}

export default Counter
